// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum MetadataIndexingStatusCodeBuf {
  /**
   * This default can never be changed
   */
  Unset = 0,
  LogicError = 1,
  TransientFailure = 2,
  BrokenFile = 3,
  DependencyFailed = 4,
  Success = 5
}
